jQuery(document).ready(function ($) {

	objectFitImages();

	var close = $('#sidebar-toggler');

	var sidebar = $('#main-sidebar');

	var body = $('body');

	if($(window).width() >= 992) {
		body.addClass('sidebar-open');
	}

	close.on('click', function () {
		body.toggleClass('sidebar-open');
	});


});